module.exports = __webpack_public_path__ + "d5beb16a9b05c0b6f61ad216b3d35987.svg";